import { render, staticRenderFns } from "./CategoryGiro.vue?vue&type=template&id=52e516fd"
import script from "./CategoryGiro.vue?vue&type=script&lang=js"
export * from "./CategoryGiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports